export default __webpack_public_path__ + "static/media/11t.1a5db9c6.jpg";